/* Galerie produit custom (compléments) — pilote stage / vignettes / dots / flèches / swipe.
   Markup : snippets/supplement-gallery.liquid. Aucune dépendance externe. */
(function () {
  'use strict';

  function initGallery(root) {
    if (!root || root.__sgInit) return;
    root.__sgInit = true;

    var stage = root.querySelector('[data-sg-stage]');
    var track = root.querySelector('[data-sg-track]');
    var slides = [].slice.call(root.querySelectorAll('[data-sg-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-sg-thumb]'));
    var dots = [].slice.call(root.querySelectorAll('[data-sg-dot]'));
    var prevBtn = root.querySelector('[data-sg-prev]');
    var nextBtn = root.querySelector('[data-sg-next]');
    var counter = root.querySelector('[data-sg-counter]');
    var n = slides.length;
    if (!track || n === 0) return;

    var index = 0;

    // object-fit adaptatif : carré → contain (pas de crop) ; rectangulaire → cover (zoom pour remplir)
    function fitImages() {
      root.querySelectorAll('.sg__img').forEach(function (img) {
        function apply() {
          var w = img.naturalWidth, h = img.naturalHeight;
          if (!w || !h) return;
          img.style.objectFit = Math.abs(w / h - 1) < 0.06 ? 'contain' : 'cover';
        }
        if (img.complete) apply(); else img.addEventListener('load', apply);
      });
    }
    fitImages();

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      slides.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      thumbs.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      dots.forEach(function (d, i) {
        var on = i === index;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (counter) counter.textContent = (index + 1) + ' / ' + n;
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === n - 1;
      scrollThumbIntoView();
    }

    function scrollThumbIntoView() {
      var at = thumbs[index];
      if (!at || !at.parentNode) return;
      var p = at.parentNode;
      var pr = p.getBoundingClientRect();
      var tr = at.getBoundingClientRect();
      if (tr.left < pr.left || tr.right > pr.right) {
        var target = p.scrollLeft + (tr.left - pr.left) - (pr.width - tr.width) / 2;
        if (p.scrollTo) p.scrollTo({ left: target, behavior: 'smooth' });
        else p.scrollLeft = target;
      }
    }

    function go(i) {
      index = Math.max(0, Math.min(n - 1, i));
      render();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

    if (stage) {
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      });
    }

    /* --- Swipe (pointer events) --- */
    if (stage && n > 1) {
      var startX = 0, startY = 0, dx = 0, dragging = false, decided = false, horiz = false, width = 1;

      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        dragging = true; decided = false; horiz = false;
        startX = e.clientX; startY = e.clientY; dx = 0;
        width = stage.getBoundingClientRect().width || 1;
      });

      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (!decided) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          decided = true;
          horiz = Math.abs(dx) > Math.abs(dy);
          if (horiz) root.classList.add('is-dragging');
        }
        if (!horiz) return;
        if (e.cancelable) e.preventDefault();
        var pct = (dx / width) * 100;
        if ((index === 0 && dx > 0) || (index === n - 1 && dx < 0)) pct *= 0.35; // résistance aux bords
        track.style.transform = 'translateX(' + (-index * 100 + pct) + '%)';
      }, { passive: false });

      var endDrag = function () {
        if (!dragging) return;
        dragging = false;
        root.classList.remove('is-dragging');
        if (!horiz) return;
        var threshold = width * 0.18;
        if (dx <= -threshold) go(index + 1);
        else if (dx >= threshold) go(index - 1);
        else render();
      };
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      root.querySelectorAll('.sg__img').forEach(function (img) {
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });
    }

    render();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sg]');
    for (var i = 0; i < roots.length; i++) initGallery(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);

  // Re-init après re-render (changement de variante : le thème re-rend le xo-product-will-change
  // qui contient la galerie → nouvelle image filtrée). initGallery est idempotent (__sgInit).
  var pending = false;
  function scheduleInit() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { pending = false; initAll(); });
  }
  if (window.MutationObserver) {
    new MutationObserver(scheduleInit).observe(document.body, { childList: true, subtree: true });
  }
})();
